export default function factory(options?: WorkerOptions | undefined): Worker {
    return new Worker(
        /* webpackChunkName: "indexeddb.worker" */ new URL("./indexeddb.worker.ts", import.meta.url),
        options,
    );
}
